const state = {
  quesData: null,
  model: null,
  modelActive: null,
  template: null,
  templateActive: null,
  levelList: null,
  questionLevel: null,
  qType: null,
  reviewActive: 0,
  reviewCount: 0, // 审核题库菜单气泡
  qStatus: 1, // 1 已入库 0 未入库
  changeTab: '0', // 审核题目tab切换
  needcache: false,
  isCompetition: false, // 竞赛试卷组题时竞赛题不显示收藏（竞赛组题普通题目显示收藏）
  queType: false, // 竞赛试卷组题时切换card标签暂存题目类型（竞赛/普通）
  options: [
    { label: '作者', value: 'createUser' },
    { label: '科室', value: 'questionDepart' },
    { label: 'ICD国际疾病编码', value: 'questionInsterCode' },
    { label: '关键字', value: 'questionKey' },
    { label: '器官', value: 'questionType' },
    { label: '题目编号', value: 'questionCode' }
  ],
  // 题库一览搜索下拉条件
  questionOptions: [
    { label: '作者', value: 'createUser' },
    { label: '科室', value: 'questionDepart' },
    { label: 'ICD国际疾病编码', value: 'questionInsterCode' },
    { label: '关键字', value: 'questionKey' },
    { label: '题目编号', value: 'questionCode' }
  ],
  currentActive: 0
}

const mutations = {
  changeNeedcache (state, v) {
    state.needcache = v;
  },
  changeQuesData: (state, obj) => {
    state.quesData = obj;
  },
  changeQuesStatus: (state, v) => {
    state.qStatus = v;
  },
  changeReviewIndex: (state, v) => {
    state.changeTab = v;
  },
  changeModel: (state, v) => {
    state.model = v;
  },
  changeModelActive: (state, v) => {
    state.modelActive = v;
  },
  changeTemplate: (state, v) => {
    state.template = v;
  },

  changeTemplateActive: (state, v) => {
    state.templateActive = v;
  },
  changeLevelList: (state, v) => {
    state.levelList = v;
  },
  changeQuestionLevel: (state, v) => {
    state.questionLevel = v;
  },
  changeQType: (state, v) => {
    state.qType = v;
  },
  changeReviewActive: (state, v) => {
    state.reviewActive = v;
  },
  changeReviewCount: (state, v) => {
    if (Array.isArray(v)) {
      state.reviewCount = v[0] + v[1];
    } else {
      state.reviewCount = v;
    }
  },
  changeCurrentActive: (state, v) => {
    state.currentActive = v;
  },
  changeIsCompetition: (state, v) => {
    state.isCompetition = v;
  },
  changeQuetype: (state, v) => {
    state.queType = v;
  }
}

const actions = {
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/ques.js